import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import SmsPolicy from './pages/SmsPolicy';
import CookiePolicy from './pages/CookiePolicy';
import FAQ from './pages/FAQ';
import Blog from './pages/Blog';
import SmsConsent from './pages/SmsConsent';
import BusinessCapitalConsulting from './pages/services/BusinessCapitalConsulting';
import UnderstandingBusinessCapital from './pages/blog/UnderstandingBusinessCapital';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/sms-policy" element={<SmsPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/sms-consent" element={<SmsConsent />} />
              <Route path="/services/business-capital-consulting" element={<BusinessCapitalConsulting />} />
              <Route path="/blog/understanding-business-capital" element={<UnderstandingBusinessCapital />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
